<div class="box">
    <div>
        <img src="assets/images/no_permission.png">
    </div>
    <div>
        <h3>{{'您没有当前页面的访问权限' | translate}}</h3><br>
        <a nz-button nzType="primary" (click)="clear()" [routerLink]="'/login'" >{{'返回登录页面' | translate}}</a>
    </div>
</div>
